import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function GetResponsibleMedicalRecordForViewUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: { id: string }) => {
    return await repository.getResponsibleMedicalRecordForView(params)
  }
}
